// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentOrderHeader_container_1Mn38","initiator":"PaymentOrderHeader_initiator_88hdc","name":"PaymentOrderHeader_name_23UA0","info":"PaymentOrderHeader_info_2SevL"};